<div id="dialog-container" class="fx-layout-col fx-fill fx-gap-20-lt-md fx-center-lt-md" [cdkTrapFocus]="true">
  @if (missingRequiredFields$ | async; as missingRequiredFields) {
    @if (missingRequiredFields.length > 0) {
      <mat-dialog-content class="creation-dialog-no-stepper fx-flex-auto">
        <span>{{ 'MESSAGE.INSUFFICIENT_FIELDS_PERMISSIONS' | translate }}</span>
        <ul>
          @for (field of missingRequiredFields; track field.code) {
            <li>{{ field.label }}</li>
          }
        </ul>
      </mat-dialog-content>
      <mat-dialog-actions class="center">
        <button mat-raised-button matDialogClose="cancel" color="accent" id="dialog-cancel-button">
          {{ 'BUTTON.CANCEL' | translate }}
        </button>
      </mat-dialog-actions>
    } @else {
      <mat-dialog-content class="fx-flex-auto fx-layout-col fx-justify-space-around fx-align-center">
        <mat-icon fontSet="mdi" [fontIcon]="iconName" [style.color]="colour" class="lg"></mat-icon>
        <div class="fx-layout-col fx-justify-start fx-align-center">
          <h3 id="title" class="modal-title">{{ title }}</h3>
          <div id="message" class="modal-message">{{ message }}</div>
        </div>
        <div></div>
      </mat-dialog-content>
      <mat-dialog-actions>
        <button mat-stroked-button matDialogClose id="dialog-cancel-button">{{ cancelText }}</button>
        <button mat-raised-button cdkFocusInitial matDialogClose="yes" color="accent" id="dialog-ok-button">{{ okText }}
        </button>
      </mat-dialog-actions>
    }
  } @else {
    <spinner></spinner>
  }
</div>
